const SvgSingleColorPalettePlaceholder = <template>
  <svg fill="none" viewBox="0 0 558 171" xmlns="http://www.w3.org/2000/svg">
    <rect
      fill="var(--primary-low--preview, #e9e9e9)"
      height="25.616"
      rx="4"
      width="120"
      x="436.298"
      y="95.819"
    />
    <rect
      fill="var(--tertiary--preview, #08c)"
      height="24.64"
      rx="4"
      width="120"
      x="436.298"
      y="144.442"
    />
    <rect
      fill="var(--tertiary-low--preview, #d1f0ff)"
      height="71.394"
      rx="4"
      width="555.265"
      x=".22"
      y=".341"
    />
    <rect
      fill="var(--danger--preview, #c80001)"
      height="24.64"
      rx="4"
      width="30"
      x="23.451"
      y="145.418"
    />
    <rect
      fill="var(--success--preview, #090)"
      height="24.64"
      rx="4"
      width="30"
      x="88.578"
      y="145.418"
    />
    <rect
      fill="var(--love--preview, #fa6c8d)"
      height="24.64"
      rx="4"
      width="30"
      x="153.704"
      y="145.418"
    />
    <rect
      fill="var(--highlight--preview, #ffff4d)"
      height="24.64"
      rx="4"
      width="30"
      x="218.831"
      y="145.418"
    />
    <rect
      fill="var(--primary--preview, #222)"
      height="4.526"
      rx="2.263"
      width="200.35"
      x="23.451"
      y="43.772"
    />
    <rect
      fill="var(--primary--preview, #222)"
      height="4.526"
      rx="2.263"
      width="333.847"
      x="23.451"
      y="66.295"
    />
    <rect
      fill="var(--primary--preview, #222)"
      height="4.526"
      rx="2.263"
      width="267.897"
      x="23.451"
      y="90.819"
    />
    <rect
      fill="var(--primary--preview, #222)"
      height="4.526"
      rx="2.263"
      width="299.961"
      x="23.451"
      y="116.342"
    />
  </svg>
</template>;

export default SvgSingleColorPalettePlaceholder;
